import React from "react";
import { Container } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";
import { ArrowBack, ArrowForward } from "@material-ui/icons";
import { LazyLoadImage } from "react-lazy-load-image-component";
import styles from "./_css/trustedPartners.module.css";
import cogir from "../../assets/images/promotePage/trust/cogir.webp";
import mondev from "../../assets/images/promotePage/trust/mondev.webp";
import brivia from "../../assets/images/promotePage/trust/brivia.webp";
import broccolini from "../../assets/images/promotePage/trust/broccoloni.webp";
import lokalia from "../../assets/images/promotePage/trust/lokalia.svg";
import samcon from "../../assets/images/promotePage/trust/samcon.webp";
import six from "../../assets/images/promotePage/trust/six.webp";
import robin from "../../assets/images/promotePage/trust/robin.webp";
import canadianApartment from "../../assets/images/promotePage/trust/canadianAppartment.png";

SwiperCore.use([Navigation, Pagination, Autoplay]);

const PARTNERS: { logo: string; name: string; key: string }[] = [
    { logo: cogir, name: "Cogir", key: "cogir" },
    { logo: mondev, name: "Mondev", key: "mondev" },
    { logo: brivia, name: "Brivia", key: "brivia" },
    { logo: broccolini, name: "Broccolini", key: "broccolini" },
    { logo: lokalia, name: "Espaces Lokalia", key: "lokalia" },
    { logo: samcon, name: "Samcon", key: "samcon" },
    { logo: six, name: "Six", key: "six" },
    { logo: robin, name: "Robin", key: "robin" },
    { logo: canadianApartment, name: "Canadian Apartment", key: "canadianApartment" },
];

export function TrustedPartners() {
    const { t } = useTranslation();

    return (
        <div className={styles.section}>
            <Container className={styles.inner}>
                <div className={styles.header}>
                    <div className={styles.headerText}>
                        <div className={styles.label}>{t("homePage.trustedPartners.label")}</div>
                        <h2 className={styles.title}>
                            <span className={styles.titleStrong}>{t("homePage.trustedPartners.titleStart")}</span>{" "}
                            <span className={styles.titleItalic}>{t("homePage.trustedPartners.titleEnd")}</span>
                        </h2>
                    </div>
                    <div className={styles.nav}>
                        <button
                            type="button"
                            className={clsx(styles.navBtn, "trustedPartners-prev")}
                            aria-label="Previous"
                        >
                            <ArrowBack />
                        </button>
                        <button type="button" className={clsx(styles.navBtn, "trustedPartners-next")} aria-label="Next">
                            <ArrowForward />
                        </button>
                    </div>
                </div>

                <Swiper
                    loop
                    speed={700}
                    spaceBetween={24}
                    autoplay={{ delay: 3000, disableOnInteraction: true }}
                    navigation={{
                        nextEl: ".trustedPartners-next",
                        prevEl: ".trustedPartners-prev",
                    }}
                    pagination={{ el: ".trustedPartners-pagination", clickable: true }}
                    slidesPerView={1.2}
                    breakpoints={{
                        480: { slidesPerView: 2 },
                        768: { slidesPerView: 3 },
                        992: { slidesPerView: 4 },
                        1280: { slidesPerView: 5 },
                    }}
                >
                    {PARTNERS.map((partner) => (
                        <SwiperSlide key={partner.key}>
                            <div className={styles.card}>
                                <div className={styles.logoWrap}>
                                    <LazyLoadImage
                                        src={partner.logo}
                                        alt={`${partner.name} logo`}
                                        className={styles.logo}
                                    />
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div className={clsx(styles.pagination, "trustedPartners-pagination")} />
            </Container>
        </div>
    );
}
